/* Arc.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { arc as d3Arc } from 'd3';
import { element } from '../../core/elements';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._v564g17y{transition:opacity .3s}";
/**
 * This is a workaround for TypeScript not inferring the correct
 * method overload/signature for some d3 shape methods.
 */
export function setNumberOrNumberAccessor(func, value) {
  if (typeof value === 'number') func(value);else func(value);
}
const arcStyles = null;
export function arc(_temp) {
  let {
    innerRadius,
    outerRadius,
    cornerRadius,
    startAngle,
    endAngle,
    padAngle,
    padRadius
  } = _temp === void 0 ? {} : _temp;
  const path = d3Arc();
  if (innerRadius != null) setNumberOrNumberAccessor(path.innerRadius, innerRadius);
  if (outerRadius != null) setNumberOrNumberAccessor(path.outerRadius, outerRadius);
  if (cornerRadius != null) setNumberOrNumberAccessor(path.cornerRadius, cornerRadius);
  if (startAngle != null) setNumberOrNumberAccessor(path.startAngle, startAngle);
  if (endAngle != null) setNumberOrNumberAccessor(path.endAngle, endAngle);
  if (padAngle != null) setNumberOrNumberAccessor(path.padAngle, padAngle);
  if (padRadius != null) setNumberOrNumberAccessor(path.padRadius, padRadius);
  return path;
}
function Arc(_ref) {
  let {
    data,
    innerRadius,
    outerRadius,
    cornerRadius,
    startAngle,
    endAngle,
    padAngle,
    padRadius,
    datum,
    opacity,
    children,
    innerRef,
    ariaLabel,
    fill,
    stroke,
    ...rest
  } = _ref;
  const path = arc({
    innerRadius,
    outerRadius,
    cornerRadius,
    startAngle,
    endAngle,
    padAngle,
    padRadius
  });
  if (children) return /*#__PURE__*/_jsx(_Fragment, {
    children: children({
      path
    })
  });
  if (!data && (startAngle == null || endAngle == null || innerRadius == null || outerRadius == null)) {
    console.warn('[@visx/shape/Arc]: expected data because one of startAngle, endAngle, innerRadius, outerRadius is undefined. Bailing.');
    return null;
  }
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx("path", {
      ref: innerRef,
      d: path(data) || '',
      role: "img",
      "aria-label": ariaLabel,
      opacity: opacity,
      fill: fill,
      stroke: stroke,
      ...rest,
      className: ax(["_v564g17y"])
    })]
  });
}
const _Arc = element(Arc);
export { _Arc as Arc };